import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { GeneralRisk } from './components/GeneralRisk/GeneralRisk';

import { Header } from './components/Header/Header';
import { ResultDetails } from './components/ResultDetails/ResultDetails';
import { Wrapper } from './Results.styles';

interface ResultsProps {
	onChangeInitialTab: (number: number) => void;
}

export const Results = ({ onChangeInitialTab }: ResultsProps) => {
	const { id } = useParams() as { id: string };
	const [hasDetails, setDetails] = useState(false);
	const ComponentType = hasDetails ? ResultDetails : GeneralRisk;

	const handleOpenDetails = () => {
		setDetails(!hasDetails);
	};

	return (
		<Wrapper>
			<Header isGeneralRisk={!hasDetails} />
			<ComponentType
				campaignId={id}
				onChangeInitialTab={onChangeInitialTab}
				onToggleDetails={handleOpenDetails}
			/>
		</Wrapper>
	);
};
